export enum ConversationTypeEnum{
    Text = 'text',
    Picture = 'picture',
    Image = 'image',
    Location= 'location',
    Zumbido='zumbido'
}


// WEBPACK FOOTER //
// ./src/utils/conversationTypeEnum.ts